export const calcRackShelfHeights = (
  baseLevelHeight: number,
  levelHeight: number,
  levelAmount: number,
  beamHeight: number,
) => {
  const levelHeights: number[] = [];
  for (let i = 0; i < levelAmount; i++) {
    levelHeights.push(baseLevelHeight + (levelHeight + beamHeight) * i);
  }

  return levelHeights;
};

export const calcMaxRackRowLength = (
  isVertical: boolean,
  boxW: number,
  boxH: number,
  margin: number,
) => (isVertical ? boxW : boxH) - margin * 2;

/**
 * @description calculates the total depth of the racking, excluding any front overhang from the first row and back overhang from the last row
 */
export const calcTotalRackFramesDepth = (
  frameDepth: number,
  framesDeepAmount: number,
  spaceBetweenFrames: number,
): number => frameDepth * framesDeepAmount + (framesDeepAmount - 1 || 0) * spaceBetweenFrames;
